const  nav = {
    name          : 'nav',
    _modals       : null,
    _closes       : null,

    init() {
        this.run();
    },

    run()
    {
        this._navItems = document.querySelectorAll('.my-account-nav__link');

        if (!this._navItems) {
            return;
        }

        for (const el of this._navItems) {
            el.addEventListener('click', function(event) {
                if (window.innerWidth < 768) {
                    if (this.classList.contains('active')) {
                        event.preventDefault();
                    }

                    this.closest('.my-account-nav').classList.toggle('toggled');
                    document.querySelector('body').classList.toggle('my-account-active-menu');
                }
            });
        }
    },


}

export { nav };
